import React from 'react'

import { Table } from '_zari/core'

import * as Rows from './rows'

const DetallesTable = ({ detalles, dispatch }) => {
  return (
    <Table
      containerId='detalles-table'
      filas={detalles}
      headRows={[
        {
          label: 'CODIGO'
        },
        {
          label: 'NOMBRE'
        },
        {
          label: 'U. MED'
        },
        {
          label: 'CANTIDAD'
        },
        {
          label: 'FEC. NECESIDAD'
        },
        {
          label: 'OBS.'
        },
        {
          label: ''
        }
      ]}
      maxRowsShown={5}
      rowTemplate={(row, k) => (
        <Rows.MainRow key={row._idFila} row={row} dispatch={dispatch} autoFocus={k + 1 === detalles.length} />
      )}
    />
  )
}

export default React.memo(DetallesTable)
